import TransferInfo from './TransferInfo';

export default TransferInfo;
